import { render } from "./ListaNegraForm.vue?vue&type=template&id=28284618"
import script from "./ListaNegraForm.vue?vue&type=script&lang=js"
export * from "./ListaNegraForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__